<template>
	<el-dialog title="监理会议" :close-on-click-modal="false" :visible.sync="subVisible" width="900px">
		<el-row class="kind_row">
			<el-col :span="12">
				<span class="kind_label">时间</span>
				<span class="kind_value_right">{{ logDate }}</span>
			</el-col>
		</el-row>
		<el-row style="margin-top: 20px;">
			<el-table :row-style="selectRowBackground" class="dataListTable" :data="dataList" header-align="center"
				style="width: 100%; margin-bottom: 10px;" border :header-cell-style="headClass"
				:row-class-name="tableRowClassName" header-cell-class-name="dataListTHeader"
				@selection-change="handleSelectionChange" :cell-style="{ padding: '0px' }">
				<el-table-column type="selection" width="45" align="center"></el-table-column>
				<el-table-column label="NO." type="index" width="60" align="center">
					<template slot-scope="scope">{{ (pageIndex2 - 1) * limit + scope.$index + 1
					}}</template>
				</el-table-column>
				<el-table-column prop="meetDate" label="时间" width="100" align="left">
				</el-table-column>
				<el-table-column prop="meetNumber" label="会议编号" width="200" align="center">
				</el-table-column>
				<el-table-column prop="meetTitle" label="会议主题" align="left" show-overflow-tooltip>
				</el-table-column>
			</el-table>
		</el-row>
		<el-row style="margin-top: 20px;">
			<el-col :span="24">
				<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
					@current-change="currentChangeHandle" :current-page="page" :page-sizes="[10, 20, 50, 100]"
					:page-size="limit" :total="totalCount" layout="total, sizes, prev, pager, next, jumper">
				</el-pagination>
			</el-col>
		</el-row>
		<el-row class="formBtnGroup">
			<el-col :span="24">
				<el-button class="btn" type="primary" size="small" @click="dataSubmit()"
					:disabled="tableSelVal.length == 0">保存</el-button>
			</el-col>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "contact-select",
	data() {
		return {
			subVisible: true,
			dataList: [],
			limit: 10,
			page: 1,
			pageIndex2: 0,
			totalCount: 0,
			selectContactItems: [],
			tableSelVal: [],
			meetIds: '',
			workLogRecNo: '',
			itemNo: '',
			sort: '',
			logDate: '',
		};
	},
	methods: {
		init(workLogRecNo, sort, itemNo, logDate, meetIds) {
			this.workLogRecNo = workLogRecNo
			this.sort = sort
			this.itemNo = itemNo
			this.logDate = logDate
			this.meetIds = meetIds
			this.$nextTick(() => {
				this.subVisible = true;
			})
			this.getProjectInfo();

		},
		getProjectInfo() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/infoName/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.executedFile = data.body.executedFile;
					this.getDataList()
				}
			});
		},
		headClass() {
			return 'background:#E1F1FF;color:#00428E;border:solid #dadada 1px;padding:1px;font-size:12px'
		},
		selGetDataList() {
			this.page = 1;
			this.getDataList();
		},
		currentChangeHandle(val) {
			this.page = val
			this.getDataList()
		},
		sizeChangeHandle(val) {
			this.limit = val
			this.page = 1
			this.getDataList()
		},
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/meetinfo/list",
				method: "get",
				params: {
					workNo: $common.getItem("workNo"),
					meetTime: this.logDate,
					meetIds: this.meetIds,
					executedFileType: this.executedFile,
					limit: this.limit,
					page: this.page
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records;
					this.totalCount = data.body.totalCount;
					this.pageIndex2 = this.page
				}
			});
		},
		dataSubmit() {
			let meetIds = this.tableSelVal.map((item) => item.meetId);
			let _url = "/business/worklogdetailinfo/saveMeetingFiles";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					workLogRecNo: this.workLogRecNo,
					meetIds: meetIds,
					sort: this.sort + 1
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.subVisible = false;
							this.$emit("refreshDataList");
						}
					});
				}
			});
		},
		handleSelectionChange(val) {
			this.tableSelVal = val;
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVal.map((item) => item.meetId);
			if (checkIdList.includes(row.meetId)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
	}
};
</script>

<style lang="scss" scoped="scoped">
.el-card {
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.kind_row {
	background-color: rgb(243, 247, 247);
	padding: 10px 0 10px 15px;
	margin-bottom: 10px;
}

.kind_label {
	color: black !important;
	font-weight: bold !important;
}

.kind_value_left {
	color: #3471b6 !important;
	font-weight: bold !important;
	margin-left: 10px;
}

.kind_value_right {
	color: black !important;
	margin-left: 20px !important;
}
</style>
